import { SnackbarProvider } from 'notistack';

import ThemeProvider from './theme';
import { AuthProvider } from './auth/AuthContext';
import { CartProvider } from './cart/CartContext';
import AppRoutes from './routes';

function App() {
  return (
    <ThemeProvider>
      <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <AuthProvider>
          <CartProvider>
            <AppRoutes />
          </CartProvider>
        </AuthProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
